if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === '1') return;
      this.dataset.bound = '1';
      this.busy = false;
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    open() {
      this.classList.add('is-open');
      document.body.classList.add('grq-drawer-open');
      const panel = this.querySelector('.grq-cart-drawer__panel');
      if (panel) {
        panel.setAttribute('aria-hidden', 'false');
        panel.focus();
      }
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('grq-drawer-open');
      const panel = this.querySelector('.grq-cart-drawer__panel');
      if (panel) panel.setAttribute('aria-hidden', 'true');
      if (this.activeElement && typeof this.activeElement.focus === 'function') {
        this.activeElement.focus();
      }
    }

    showError(message) {
      const el = this.querySelector('[data-grq-drawer-error]');
      if (!el) return;
      el.hidden = !message;
      el.textContent = message || '';
    }

    renderContents(parsed) {
      const html = parsed && parsed.sections && parsed.sections['cart-drawer'];
      const inner = this.querySelector('[data-grq-drawer-inner]');
      if (html && inner) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-grq-drawer-inner]');
        if (next) inner.innerHTML = next.innerHTML;
      }
      this.updateBubble(parsed);
      this.open();
    }

    updateBubble(parsed) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (!bubble || !parsed) return;
      const html = parsed.sections && parsed.sections['cart-icon-bubble'];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('.shopify-section');
        if (section && section.textContent.trim()) {
          bubble.innerHTML = section.innerHTML;
          return;
        }
      }
      if (parsed.item_count == null) return;
      let badge = bubble.querySelector('.cart-count-bubble');
      if (parsed.item_count > 0) {
        if (!badge) {
          badge = document.createElement('div');
          badge.className = 'cart-count-bubble';
          bubble.appendChild(badge);
        }
        badge.innerHTML = '<span aria-hidden="true">' + parsed.item_count + '</span>';
      } else if (badge) {
        badge.remove();
      }
    }

    async post(url, payload) {
      this.busy = true;
      this.classList.add('is-busy');
      try {
        const routes = window.routes || {};
        const response = await fetch(url || routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(Object.assign({
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname || '/'
          }, payload))
        });
        const parsed = await response.json();
        if (!response.ok || parsed.status) {
          this.showError(parsed.description || parsed.message || this.dataset.msgError || '');
          return null;
        }
        return parsed;
      } catch (error) {
        this.showError(this.dataset.msgError || '');
        return null;
      } finally {
        this.busy = false;
        this.classList.remove('is-busy');
      }
    }

    async change(key, quantity) {
      if (this.busy || !key) return;
      const routes = window.routes || {};
      const parsed = await this.post(routes.cart_change_url, { id: key, quantity: quantity });
      if (parsed) this.renderContents(parsed);
    }

    async applyDiscount(code) {
      if (this.busy) return;
      const routes = window.routes || {};
      const parsed = await this.post(routes.cart_update_url, { discount: code });
      if (!parsed) return;
      this.renderContents(parsed);
      const wanted = (code || '').trim().toLowerCase();
      if (!wanted) return;
      const codes = parsed.discount_codes || [];
      const rejected = codes.some((entry) => String(entry.code || '').toLowerCase() === wanted && entry.applicable === false);
      const applied = codes.some((entry) => String(entry.code || '').toLowerCase() === wanted && entry.applicable !== false);
      if (rejected || (codes.length && !applied)) this.showError(this.dataset.msgCode || '');
    }

    onClick(event) {
      if (event.target.closest('[data-grq-drawer-close]')) {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.target.closest('[data-grq-clear-discount]')) {
        event.preventDefault();
        this.applyDiscount('');
        return;
      }
      const button = event.target.closest('button[name="minus"], button[name="plus"], button[name="remove"]');
      if (!button) return;
      event.preventDefault();
      const line = button.closest('[data-key]');
      if (!line) return;
      const input = line.querySelector('.quantity__input');
      let quantity = input ? parseInt(input.value, 10) || 1 : 1;
      if (button.name === 'minus') quantity = Math.max(1, quantity - 1);
      if (button.name === 'plus') quantity += 1;
      if (button.name === 'remove') quantity = 0;
      this.change(line.dataset.key, quantity);
    }

    onChange(event) {
      const input = event.target.closest('.quantity__input');
      if (!input) return;
      const line = input.closest('[data-key]');
      if (!line) return;
      const quantity = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = String(quantity);
      this.change(line.dataset.key, quantity);
    }

    onSubmit(event) {
      const form = event.target;
      if (!form.matches || !form.matches('[data-grq-discount]')) return;
      event.preventDefault();
      const input = form.querySelector('input[name="discount"]');
      const code = input ? input.value.trim() : '';
      if (!code) return;
      this.applyDiscount(code);
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  if (!window.__grqDrawerIcon) {
    window.__grqDrawerIcon = true;
    document.addEventListener('click', (event) => {
      const icon = event.target.closest && event.target.closest('#cart-icon-bubble');
      if (!icon) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      drawer.open();
    });
  }
}
